<div class="login-container">
  <div class="login-header">
    <span class="heading">Welcome to Blue Shield of California CS Admin</span>
  </div>
  <div class="wel_left">
    <div>
      <table class="login-table" cellpadding="0" cellspacing="0">
        <tr>
          <td colspan="2">
            @if (errorMessage) {
              <span class="error-msg" [innerHTML]="errorMessage"></span>
            }
          </td>
        </tr>
        <tr>
          <td class="wid-120"></td>
          <td class="wid-280">
            <div id="searchbutton">
              <button class="login" type="button" (click)="adLogin()">
                <img class="login-img" src="assets/images/but_login.png" alt="AD Login" />
              </button>
            </div>
          </td>
        </tr>
        <tr>
          <td class="wid-120"></td>
          <td class="wid-280">
            <!-- <span class="hintMessage">
              Please use your AD credentials to login.
            </span> -->
          </td>
        </tr>
        <tr>
          <td class="wid-120"></td>
          <td class="wid-280">
            <span class="hintMessage1">
              	
Do not attempt to log in unless you are an authorized user. Unauthorized use of this application could be considered criminal activity and maybe punishable by law.
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>